//REGISTER
export const POST_FAKE_REGISTER = "/auth/signup";
export const POST_LOGIN = "/auth/login";
//LOGIN
export const POST_FAKE_LOGIN = "/auth/signin";
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login";
export const POST_FAKE_PASSWORD_FORGET = "/auth/forgot-password";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

// CRM
// Users
export const GET_USERS = "/users";
export const ADD_NEW_USER = "/auth/register";
export const ADD_NEW_EMPLOYEE = "/users/register";
export const CHANGE_PWD = "/users/changepwd";
export const UPDATE_USER = "/users";
export const UPDATE_EMPLOYEE = "/users/employee";
export const DELETE_USER = "/users";
export const UPDATE_HEARTBEAT_USER = "/auth/heartbeat";

// ExchangeRates
export const GET_EXCHANGE_RATES = "/auth/rates";

// LOGISTICS
// Companies
export const GET_COMPANIES = "/companies";
export const ADD_NEW_COMPANY = "/companies/register";
export const UPDATE_COMPANY = "/companies";
export const DELETE_COMPANY = "/companies";

// LOGISTICS
// Containers
export const GET_CONTAINERS = "/containers";
export const GET_CONTAINERS_BWAREHOUSES = "/containers/bwarehouses";
export const GET_CONTAINERS_GETFILTERS = "/containers/getfilters";
export const GET_CONTAINERS_GETFILTERS_EXPORT = "/containers/getfiltersexport";
export const GET_CONTAINERS_STATS = "/containers/stats";
export const GET_CONTAINERS_GENSTATS = "/containers/genstats";
export const GET_CONTAINER_BYID = "/containers/print";
export const GET_CONTAINERS_FILTERALL = "/containers/filterall";
export const GET_CONTAINERSFILTER = "/containers/filter";
export const ADD_NEW_CONTAINER = "/containers/register";
export const UPDATE_CONTAINER = "/containers";
export const DELETE_CONTAINER = "/containers";

// Additional Fees
export const GET_ADDFEES = "/addfees";
export const ADD_NEW_ADDFEE = "/addfees/register";
export const UPDATE_ADDFEE = "/addfees";
export const DELETE_ADDFEE = "/addfees";

// Container Logs (Admin only)
export const GET_CONTAINERLOGS_GETFILTERS = "/containerlogs/getfilters";
export const DELETE_CONTAINERLOGS_BULK    = "/containerlogs/bulk";

// Various Fees
export const GET_VFEES = "/vfees";
export const GET_VFEES_GETFILTERS = "/vfees/getfilters";
export const GET_VFEES_GETFILTERS_EXPORT = "/vfees/getfiltersexport";
export const GET_VFEES_BYCLIENT = "/vfees/byclient";
export const GET_VFEES_BALANCE = "/vfees/balance";
export const GET_VFEES_BALANCE_CLIENT = "/vfees/balanceclient";
export const GET_VFEES_COMPANY = "/vfees/company";
export const FIND_BYID = "/vfees/findbyid";
export const FIND_VFEE = "/vfees/find";
export const ADD_NEW_VFEE = "/vfees/register";
export const UPDATE_VFEE = "/vfees";
export const DELETE_VFEE = "/vfees";
export const GET_VFEE_BYNUMBER = "/vfees/print";
export const UPDATE_VFEE_LOCK = "/vfees/lock";
export const GET_VFEES_DELETED = "/vfees/deleted";

// Receivers
export const GET_FIND_RECEIVERS = "/receivers/find";
export const GET_RECEIVERS_GETFILTERS = "/receivers/getfilterreceivers";
export const GET_RECEIVERS_GETFILTERS_EXPORT =
  "/receivers/getfilterreceiversexport";
export const ADD_NEW_RECEIVER = "/receivers/register";
export const ADD_NEW_RECEIVER_CLIENT = "/receivers/cregister";
export const UPDATE_RECEIVER = "/receivers";
export const DELETE_RECEIVER = "/receivers";

// Vehicles
export const GET_VEHICLES = "/vehicles";
export const GET_VEHICLES_GETFILTERS = "/vehicles/getfilters";
export const GET_VEHICLES_GETFILTERS_EXPORT = "/vehicles/getfiltersexport";
export const ADD_NEW_VEHICLE = "/vehicles/register";
export const UPDATE_VEHICLE = "/vehicles";
export const DELETE_VEHICLE = "/vehicles";
export const GET_CLIENT_VEHICLES = "/vehicles/client";

// Orders
export const GET_ORDERS = "/orders";
export const GET_ORDERS_STATS = "/orders/stats";
export const GET_ORDERS_DASHBOARD_SUMMARY = "/orders/dashboard-summary";
export const GET_ORDERS_DASHBOARD_MANAGERS = "/orders/dashboard-managers";
export const GET_ORDERS_TRANSPORT_STATS = "/orders/transport-stats";
export const ADD_NEW_ORDER = "/orders/register";
export const UPDATE_ORDER = "/orders";
export const UPDATE_BULK_ORDER = "/orders/bulk";
export const DELETE_ORDER = "/orders";
export const GET_ORDERS_BYFR = "/orders/ordersbyfr";
export const GET_CLIENT_ORDERS = "/orders/client";

// Quotes
export const GET_QUOTES = "/quotes";
export const GET_QUOTES_STATS = "/quotes/stats";
export const ADD_NEW_QUOTE = "/quotes/register";
export const UPDATE_QUOTE = "/quotes";
export const DELETE_QUOTE = "/quotes";

// Web Quotation
export const GET_WEBQUOTATION = "/wquote";
export const ADD_NEW_WEBQUOTATION = "/wquote/register";
export const UPDATE_WEBQUOTATION = "/wquote";
export const DELETE_WEBQUOTATION = "/wquote";

// OrdersReceivers
export const GET_ORDERS_RECEIVERS = "/orders/receivers";
export const GET_ORDERS_RECEIVERS_FIND = "/orders/receiversfind";
export const ADD_NEW_ORDER_RECEIVER = "/orders/receivers/register";
export const UPDATE_ORDER_RECEIVER = "/orders/receivers";
export const DELETE_ORDER_RECEIVER = "/orders/receivers";

// OrdersSender
export const GET_ORDERS_SENDERS = "/orders/senders";
export const GET_ORDERS_SENDERS_FIND = "/orders/sendersfind";
export const ADD_NEW_ORDER_SENDER = "/orders/senders/register";
export const UPDATE_ORDER_SENDER = "/orders/senders";
export const DELETE_ORDER_SENDER = "/orders/senders";

// CustomClearance
export const GET_CUSTOM_CLEARANCES = "/orders/customclearances";
export const ADD_NEW_CUSTOM_CLEARANCE = "/orders/customclearances/register";
export const UPDATE_CUSTOM_CLEARANCE = "/orders/customclearances";
export const DELETE_CUSTOM_CLEARANCE = "/orders/customclearances";

// CustomDeclaration
export const GET_CUSTOM_DECLARATIONS = "/orders/customdeclarations";
export const ADD_NEW_CUSTOM_DECLARATION = "/orders/customdeclarations/register";
export const UPDATE_CUSTOM_DECLARATION = "/orders/customdeclarations";
export const DELETE_CUSTOM_DECLARATION = "/orders/customdeclarations";

// TIL
// Invoices
export const GET_INVOICES = "/invoices";
export const ADD_NEW_INVOICE = "/invoices/register";
export const UPDATE_INVOICE = "/invoices";
export const DELETE_INVOICE = "/invoices";
export const GET_INVOICE_BYNUMBER = "/invoices/print";

// MInvoices
export const GET_MINVOICES = "/minvoices";
export const ADD_NEW_MINVOICE = "/minvoices/register";
export const UPDATE_MINVOICE = "/minvoices";
export const DELETE_MINVOICE = "/minvoices";
export const GET_MINVOICE_BYNUMBER = "/minvoices/print";

// OrderInvoices
export const GET_ORDER_INVOICES = "/orderinvoices";
export const ADD_NEW_ORDER_INVOICE = "/orderinvoices/register";
export const UPDATE_ORDER_INVOICE = "/orderinvoices";
export const DELETE_ORDER_INVOICE = "/orderinvoices";
export const GET_ORDER_INVOICE_BYNUMBER = "/orderinvoices/print";
export const GET_ORDER_INVOICE_BYORDERID = "/orderinvoices/by-order";

export const ADD_BANK_TRANSACTION_REQUEST = "/orderinvoices";
export const ADD_BANK_TRANSACTION_BY_ORDER_REQUEST = "/orderinvoices/by-order";
export const UPDATE_BANK_TRANSACTION_REQUEST = "/orderinvoices";
export const DELETE_BANK_TRANSACTION_REQUEST = "/orderinvoices";

export const GET_ADDITIONAL_INVOICES_BY_ORDER = "/orderinvoices/by-order";
export const ADD_ADDITIONAL_INVOICE_BY_ORDER = "/orderinvoices/by-order";
export const CREATE_CONSOLIDATED_INVOICE = "/orderinvoices/consolidated";

// Documents
export const GET_DOCUMENTS = "/documents";
export const ADD_NEW_DOCUMENT = "/documents/register";
export const UPDATE_DOCUMENT = "/documents";
export const DELETE_DOCUMENT = "/documents";

// Archives
export const GET_ARCHIVES    = "/documents/archives";
export const ADD_NEW_ARCHIVE = "/documents/archive/register";
export const UPDATE_ARCHIVE  = "/documents/archive";
export const DELETE_ARCHIVE  = "/documents/archive";
export const GET_FOLDERS     = "/documents/folders";
export const ADD_NEW_FOLDER  = "/documents/folders";
export const DELETE_FOLDER   = "/documents/folders";

// Requests
export const GET_REQUESTS = "/requests";
export const ADD_NEW_REQUEST = "/requests/register";
export const UPDATE_REQUEST = "/requests";
export const DELETE_REQUEST = "/requests";

// Warehouses
export const GET_WAREHOUSES = "/warehouses/deposit";
export const ADD_NEW_WAREHOUSE = "/warehouses/deposit/register";
export const UPDATE_WAREHOUSE = "/warehouses/deposit";
export const DELETE_WAREHOUSE = "/warehouses/deposit";
export const GET_WAREHOUSES_COMPANIES = "/warehouses/companies";

export const GET_WAREHOUSES_WITHDRAW = "/warehouses/withdraw";
export const ADD_NEW_WAREHOUSE_WITHDRAW = "/warehouses/withdraw/register";
export const UPDATE_WAREHOUSE_WITHDRAW = "/warehouses/withdraw";
export const DELETE_WAREHOUSE_WITHDRAW = "/warehouses/withdraw";

export const GET_WAREHOUSES_SUMMARY = "/warehouses/report/full";
export const GET_WAREHOUSES_INVOICE = "/warehouses/report/invoice";

export const GET_WAREHOUSES_INVOICES = "/warehouses/invoices";
export const ADD_NEW_WAREHOUSES_INVOICE = "/warehouses/invoices/register";
export const UPDATE_WAREHOUSES_INVOICE = "/warehouses/invoices";
export const DELETE_WAREHOUSES_INVOICE = "/warehouses/invoices";
export const GET_WAREHOUSES_INVOICE_BYNUMBER = "/warehouses/invoices/print";

// Temp Warehouses (GTA)
export const GET_TEMP_WAREHOUSES_DEPOSIT = "/tempwarehouses/deposit";
export const ADD_NEW_TEMP_WAREHOUSE_DEPOSIT = "/tempwarehouses/deposit/register";
export const UPDATE_TEMP_WAREHOUSE_DEPOSIT = "/tempwarehouses/deposit";
export const DELETE_TEMP_WAREHOUSE_DEPOSIT = "/tempwarehouses/deposit";

export const GET_TEMP_WAREHOUSES_WITHDRAW = "/tempwarehouses/withdraw";
export const ADD_NEW_TEMP_WAREHOUSE_WITHDRAW = "/tempwarehouses/withdraw/register";
export const UPDATE_TEMP_WAREHOUSE_WITHDRAW = "/tempwarehouses/withdraw";
export const DELETE_TEMP_WAREHOUSE_WITHDRAW = "/tempwarehouses/withdraw";

export const GET_TEMP_WAREHOUSES_SUMMARY = "/tempwarehouses/summary/list";
export const ADD_NEW_TEMP_WAREHOUSE_SUMMARY = "/tempwarehouses/summary/register";
export const UPDATE_TEMP_WAREHOUSE_SUMMARY_LOCATION = "/tempwarehouses/summary/receiver-location";
export const DELETE_TEMP_WAREHOUSE_LOCATION_HISTORY = "/tempwarehouses/summary/receiver-location-history";
export const GET_GTA_LOCATION_MAP = "/tempwarehouses/summary/location-map";
export const GTA_RELEASE = "/tempwarehouses/gta-release";
export const GTA_RELEASE_BULK = "/tempwarehouses/gta-release-bulk";
export const GET_TEMP_WAREHOUSES_WITHDRAW_LIST = "/tempwarehouses/withdraw/list";
export const GET_TEMP_WAREHOUSES_DEPOSIT_LIST = "/tempwarehouses/deposit/list";
export const GENERATE_TEMP_WAREHOUSE_SUMMARY_QRCODES = "/tempwarehouses/summary/generate-qrcodes";

export const GET_FILES = "/users/getfiles";
export const GET_FILES_TRANSPORT = "/users/getfilestransport";
export const GET_UPLOAD = "/users/upload";
export const GET_UPLOAD_TRANSPORT = "/users/uploadtransport";
export const DELETE_FILE = "/users/deletefile";
export const UPDATE_FILE = "/users/updatefiles";

export const GET_NOTIFICATIONS = "/notifications/find";
export const ADD_NEW_NOTIFICATION = "/notifications/register";
export const UPDATE_NOTIFICATION = "/notifications/read";
export const DELETE_NOTIFICATION = "/notifications";

// Job Posts
export const GET_JOB_POSTS = "/jobposts";
export const GET_JOB_POSTS_STATS = "/jobposts/stats";
export const ADD_NEW_JOB_POST = "/jobposts/register";
export const UPDATE_JOB_POST = "/jobposts";
export const DELETE_JOB_POST = "/jobposts";

// Job Applications
export const GET_JOB_APPLICATIONS = "/jobapplications";
export const GET_JOB_APPLICATIONS_COUNTS = "/jobapplications/counts";
export const UPDATE_JOB_APPLICATION_STATUS = "/jobapplications";

// News
export const GET_NEWS          = "/news";
export const GET_NEWS_STATS    = "/news/stats";
export const ADD_NEWS          = "/news/register";
export const UPDATE_NEWS       = "/news";
export const DELETE_NEWS       = "/news";
export const UPLOAD_NEWS_COVER = "/news/upload-cover";

// News Categories
export const GET_NEWS_CATEGORIES    = "/newscategories";
export const ADD_NEWS_CATEGORY      = "/newscategories";
export const UPDATE_NEWS_CATEGORY   = "/newscategories";
export const DELETE_NEWS_CATEGORY   = "/newscategories";

// Landing
export const GET_LANDING = "/landing";
export const ADD_NEW_LANDING = "/landing/register";
export const UPDATE_LANDING = "/landing";
export const DELETE_LANDING = "/landing";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/user";
